import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e0b0249"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag__label" }

import BaseIcon from '@/components/BaseIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTag',
  props: {
  label: {
    type: String,
    default: '',
  },
  hideClose: {
    type: Boolean,
    default: false,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: undefined,
    validator: (value: string) => ['chip'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tag", {
      'tag--read-only': __props.readOnly,
      'tag--disabled': __props.disabled,
      [`tag--${__props.type}`]: __props.type,
    }])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    (!__props.hideClose)
      ? (_openBlock(), _createBlock(BaseIcon, {
          key: 0,
          icon: __props.type === 'chip' ? 'plus' : 'close',
          size: __props.type === 'chip' ? 16 : 10,
          class: "tag__icon"
        }, null, 8, ["icon", "size"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})